/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateReferralProgramDto } from '../models/CreateReferralProgramDto';
import type { GetAllReferralsEntity } from '../models/GetAllReferralsEntity';
import type { GetReferralProgramEntity } from '../models/GetReferralProgramEntity';
import type { UpdateReferralProgramDto } from '../models/UpdateReferralProgramDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReferralProgramService {

    /**
     * @returns GetReferralProgramEntity
     * @throws ApiError
     */
    public static referralProgramControllerGetReferralProgram(): CancelablePromise<GetReferralProgramEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/referral-program',
        });
    }

    /**
     * @param requestBody
     * @returns GetReferralProgramEntity
     * @throws ApiError
     */
    public static referralProgramControllerCreateReferralProgram(
        requestBody: CreateReferralProgramDto,
    ): CancelablePromise<GetReferralProgramEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/referral-program',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns GetReferralProgramEntity
     * @throws ApiError
     */
    public static referralProgramControllerPatchReferralProgram(
        requestBody: UpdateReferralProgramDto,
    ): CancelablePromise<GetReferralProgramEntity> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/referral-program',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param page
     * @param limit
     * @returns GetAllReferralsEntity
     * @throws ApiError
     */
    public static referralProgramControllerGetAllReferrals(
        page: string = '1',
        limit: string = '10',
    ): CancelablePromise<GetAllReferralsEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/referral-program/referrals',
            query: {
                'page': page,
                'limit': limit,
            },
        });
    }

}
